/* =========================================================================
   CIELÚ — interacción de las secciones propias (sin librerías externas)
   Cada componente arranca solo si su elemento existe en la página.
   ========================================================================= */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Utilidades ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || '${{amount_with_comma_separator}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? '.' : thousands;
      decimal = decimal == null ? ',' : decimal;
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var m = format.match(placeholder);
    var key = m ? m[1] : 'amount_with_comma_separator';
    var value;
    switch (key) {
      case 'amount': value = fmt(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2, '.', ',');
    }
    // como el filtro money_without_trailing_zeros: $79.900 en vez de $79.900,00
    value = value.replace(/[.,]00$/, '');
    return format.replace(placeholder, value).replace(/&amp;/g, '&');
  }

  /* ---------- Aparición al hacer scroll ---------- */
  function initReveal(root) {
    var els = $$('.cl-rev:not(.is-in)', root);
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var vh = window.innerHeight;
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.95 && r.bottom > 0) el.classList.add('is-in');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { if (!el.classList.contains('is-in')) io.observe(el); });
  }

  /* ---------- Videos que se reproducen solos cuando se ven ---------- */
  var videoIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting && !v.closest('[data-cl-panel]:not(.is-on)')) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else { v.pause(); }
    });
  }, { threshold: 0.25 }) : null;
  function initVideos(root) {
    $$('.cl-sec video', root).forEach(function (v) {
      v.muted = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      v.removeAttribute('autoplay');
      if (videoIO && !reduceMotion) videoIO.observe(v);
    });
  }

  /* ---------- Videos tipo reel: al tocarlos se ven en pantalla completa ---------- */
  function initReels(root) {
    $$('[data-cl-reel]', root).forEach(function (b) {
      if (b.clReady) return; b.clReady = true;
      b.addEventListener('click', function () {
        var v = b.querySelector('video');
        if (!v) return;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        if (v.requestFullscreen) { v.requestFullscreen().catch(function () {}); }
        else if (v.webkitEnterFullscreen) { v.webkitEnterFullscreen(); }
      });
    });
  }

  /* ---------- Galería del producto ---------- */
  function initGaleria(root) {
    $$('[data-cl-gal]', root).forEach(function (gal) {
      if (gal.clReady) return; gal.clReady = true;
      var pista = $('[data-cl-gal-pista]', gal);
      if (!pista) return;
      var slides = $$('[data-cl-slide]', pista);
      var minis = $$('[data-cl-mini]', gal);
      var puntos = $$('[data-cl-punto]', gal);
      var prev = $('[data-cl-gal-prev]', gal);
      var next = $('[data-cl-gal-next]', gal);
      var actual = 0;

      function marcar(i) {
        actual = i;
        minis.forEach(function (m, k) { m.classList.toggle('is-on', k === i); m.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        puntos.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= slides.length - 1;
        slides.forEach(function (s, k) {
          var v = s.querySelector('video');
          if (v && k !== i) v.pause();
        });
        var mini = minis[i];
        if (mini && mini.parentNode) {
          var c = mini.parentNode;
          var left = mini.offsetLeft - c.clientWidth / 2 + mini.clientWidth / 2;
          c.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }
      function ir(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        pista.scrollTo({ left: slides[i].offsetLeft - pista.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        marcar(i);
      }
      var t;
      pista.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth));
          if (i !== actual) marcar(i);
        }, 60);
      }, { passive: true });
      minis.forEach(function (m, k) { m.addEventListener('click', function () { ir(k); }); });
      puntos.forEach(function (p, k) { p.addEventListener('click', function () { ir(k); }); });
      if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
      if (next) next.addEventListener('click', function () { ir(actual + 1); });
      gal.clIrAMedia = function (mediaId) {
        for (var k = 0; k < slides.length; k++) {
          if (String(slides[k].getAttribute('data-media-id')) === String(mediaId)) { ir(k); return; }
        }
      };
      /* Fotos del tema (sin fotos en el producto): salta a la primera foto marcada con el color elegido */
      gal.clIrAOpcion = function (valores) {
        var handle = function (t) { return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); };
        var buscados = (valores || []).map(handle);
        for (var k = 0; k < slides.length; k++) {
          var op = slides[k].getAttribute('data-cl-foto-color');
          if (op && buscados.indexOf(op) > -1) { ir(k); return; }
        }
      };
      marcar(0);
    });
  }

  /* ---------- Producto: opciones, precio, botón y barra fija ---------- */
  function initProducto(root) {
    $$('[data-cl-producto]', root).forEach(function (pd) {
      if (pd.clReady) return; pd.clReady = true;
      var dataEl = $('[data-cl-variantes]', pd);
      var variantes = [];
      try { variantes = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variantes = []; }
      var formato = pd.getAttribute('data-money-format') || '${{amount_with_comma_separator}}';
      var cuotas = parseInt(pd.getAttribute('data-cuotas') || '0', 10);
      var transf = parseFloat(pd.getAttribute('data-transferencia') || '0');
      var textoAgregar = pd.getAttribute('data-texto-agregar') || 'Agregar al carrito';
      var textoAgotado = pd.getAttribute('data-texto-agotado') || 'Sin stock por ahora';
      var form = $('form[action*="/cart/add"]', pd);
      var inputId = form ? form.querySelector('[name="id"]') : null;
      var boton = $('[data-cl-comprar]', pd);
      var grupos = $$('[data-cl-opcion]', pd);
      var gal = $('[data-cl-gal]', pd);
      var sticky = document.querySelector('[data-cl-sticky="' + pd.getAttribute('data-seccion') + '"]');

      function seleccion() {
        return grupos.map(function (g) {
          var r = g.querySelector('input:checked');
          return r ? r.value : null;
        });
      }
      function buscar(opts) {
        for (var i = 0; i < variantes.length; i++) {
          var v = variantes[i], ok = true;
          for (var k = 0; k < opts.length; k++) { if (v.options[k] !== opts[k]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      }
      function pintarPrecios(v) {
        var precio = v ? v.price : 0;
        $$('[data-cl-precio]', document).forEach(function (el) {
          if (el.closest('[data-cl-producto]') === pd || el.closest('[data-cl-sticky="' + pd.getAttribute('data-seccion') + '"]')) el.textContent = formatMoney(precio, formato);
        });
        var antes = $('[data-cl-antes]', pd);
        var off = $('[data-cl-off]', pd);
        if (antes) {
          if (v && v.compare_at_price && v.compare_at_price > v.price) {
            antes.textContent = formatMoney(v.compare_at_price, formato);
            antes.hidden = false;
            if (off) { off.textContent = Math.round((1 - v.price / v.compare_at_price) * 100) + '% OFF'; off.hidden = false; }
          } else { antes.hidden = true; if (off) off.hidden = true; }
        }
        var reloj = $('[data-cl-reloj]', pd);
        if (reloj) reloj.classList.toggle('is-off', !(v && v.compare_at_price && v.compare_at_price > v.price));
        var c = $('[data-cl-cuota]', pd);
        if (c && cuotas > 0) c.textContent = formatMoney(Math.round(precio / cuotas / 100) * 100, formato); // redondeada al peso
        var tr = $('[data-cl-transf]', pd);
        if (tr && transf > 0) tr.textContent = formatMoney(Math.floor(precio * (100 - transf) / 100), formato);
      }
      function pintarBoton(v) {
        var disponible = !!(v && v.available);
        [boton, sticky ? $('[data-cl-sticky-btn]', sticky) : null].forEach(function (b) {
          if (!b) return;
          var span = b.querySelector('span');
          if (disponible) { b.removeAttribute('disabled'); b.removeAttribute('aria-disabled'); if (span) span.textContent = b.hasAttribute('data-cl-sticky-btn') ? (b.getAttribute('data-texto') || textoAgregar) : textoAgregar; }
          else { b.setAttribute('disabled', 'disabled'); if (span) span.textContent = v ? textoAgotado : 'No disponible'; }
        });
      }
      function pintarAgotados(opts) {
        grupos.forEach(function (g, gi) {
          $$('input', g).forEach(function (inp) {
            var prueba = opts.slice(); prueba[gi] = inp.value;
            var v = buscar(prueba);
            var lbl = inp.nextElementSibling;
            if (lbl) lbl.classList.toggle('is-agotado', !(v && v.available));
          });
          var r = g.querySelector('input:checked');
          var out = g.querySelector('[data-cl-opcion-valor]');
          if (out && r) out.textContent = r.value;
        });
      }
      function pintarUrgencia(v) {
        var el = $('[data-cl-urgencia]', pd);
        if (!el) return;
        var txt = el.querySelector('[data-cl-urgencia-txt]');
        var stock = {};
        try { stock = JSON.parse(el.getAttribute('data-stock') || '{}'); } catch (e) { stock = {}; }
        var q = v ? stock[String(v.id)] : null;
        var umbral = parseInt(el.getAttribute('data-umbral') || '0', 10);
        var conCantidad = el.getAttribute('data-texto-stock');
        el.hidden = !(v && v.available);
        if (!txt) return;
        if (typeof q === 'number' && q > 0 && q <= umbral && conCantidad) {
          var conN = conCantidad.replace('[n]', q);
          txt.textContent = q === 1 ? conN.replace('Quedan', 'Queda').replace('unidades', 'unidad') : conN;
        } else txt.textContent = el.getAttribute('data-texto') || txt.textContent;
      }
      function cambiar(desdeUsuario) {
        var opts = seleccion();
        var v = buscar(opts);
        if (inputId && v) inputId.value = v.id;
        pintarPrecios(v);
        pintarBoton(v);
        pintarUrgencia(v);
        pintarAgotados(opts);
        if (v && desdeUsuario) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', u.toString());
          } catch (e) {}
          if (v.featured_media && gal && gal.clIrAMedia) gal.clIrAMedia(v.featured_media.id);
          else if (gal && gal.clIrAOpcion) gal.clIrAOpcion(v.options);
          if (sticky) {
            var img = $('[data-cl-sticky-img]', sticky);
            if (img && v.featured_image && v.featured_image.src) { img.src = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=120'; }
          }
        }
      }
      grupos.forEach(function (g) { g.addEventListener('change', function () { cambiar(true); }); });
      if (grupos.length) cambiar(false);

      // "Ver más beneficios"
      $$('[data-cl-mas-beneficios]', pd).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var lista = document.getElementById(btn.getAttribute('aria-controls'));
          if (!lista) return;
          var abierto = lista.classList.toggle('is-abierto');
          btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
          var t = btn.querySelector('span');
          if (t) t.textContent = abierto ? (btn.getAttribute('data-menos') || 'Ver menos') : (btn.getAttribute('data-mas') || 'Ver más');
        });
      });

      // Barra de compra fija: aparece cuando el botón principal quedó arriba
      // y se esconde al llegar al pie, para que se vean los datos legales.
      if (sticky && boton && 'IntersectionObserver' in window) {
        var stickyBtn = $('[data-cl-sticky-btn]', sticky);
        var pasoBoton = false, pieVisible = false;
        var actualizarSticky = function () {
          var mostrar = pasoBoton && !pieVisible;
          sticky.classList.toggle('is-on', mostrar);
          sticky.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
          document.body.classList.toggle('cl-con-sticky', mostrar);
          // El botón de WhatsApp se ubica arriba de la barra, midiendo su altura real
          if (mostrar) document.body.style.setProperty('--cl-sticky-h', sticky.offsetHeight + 'px');
        };
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { pasoBoton = !en.isIntersecting && en.boundingClientRect.top < 0; });
          actualizarSticky();
        }, { threshold: 0 }).observe(boton);
        var pie = document.querySelector('.cl-pie') || document.querySelector('footer');
        if (pie) new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { pieVisible = en.isIntersecting; });
          actualizarSticky();
        }, { threshold: 0 }).observe(pie);
        if (stickyBtn) stickyBtn.addEventListener('click', function (e) {
          e.preventDefault();
          if (boton.hasAttribute('disabled')) { boton.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          if (form && form.requestSubmit) form.requestSubmit(boton); else boton.click();
        });
      }

      // Si ese color ya está en el carrito, abre el carrito en vez de sumar otra unidad.
      // Sin esto, quien vuelve del pago y toca de nuevo el botón llega con 2 o 3 mochilas.
      if (form) form.addEventListener('submit', function (e) {
        if (form.clSumar) { form.clSumar = false; return; }
        var id = inputId ? String(inputId.value) : '';
        var drawer = document.querySelector('cart-drawer');
        if (!id || !drawer || !drawer.renderContents || !window.fetch) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var submitter = e.submitter || boton;
        var sumar = function () {
          form.clSumar = true;
          if (form.requestSubmit) form.requestSubmit(submitter); else boton.click();
        };
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var esta = (cart.items || []).some(function (it) { return String(it.variant_id) === id; });
            if (!esta) return sumar();
            return fetch('/?sections=cart-drawer,cart-icon-bubble')
              .then(function (r) { return r.json(); })
              .then(function (secciones) { drawer.renderContents({ id: id, sections: secciones }); })
              .catch(function () { drawer.open(); });
          })
          .catch(sumar);
      }, true);
    });
  }

  /* ---------- Línea de despacho: "Si comprás hoy lunes, sale el miércoles 8" ---------- */
  function initDespacho(root) {
    $$('[data-cl-despacho]', root).forEach(function (el) {
      var dias = parseInt(el.getAttribute('data-dias') || '2', 10);
      var plantilla = el.getAttribute('data-plantilla');
      if (!plantilla) return;
      var tz = 'America/Argentina/Buenos_Aires';
      var hoy;
      try {
        var p = new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
        hoy = new Date(p + 'T12:00:00');
      } catch (e) { hoy = new Date(); }
      var d = new Date(hoy.getTime());
      var n = 0;
      while (n < dias) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) n++;
      }
      var dia = function (x) { return x.toLocaleDateString('es-AR', { weekday: 'long' }); };
      var fecha = function (x) { return x.toLocaleDateString('es-AR', { weekday: 'long', day: 'numeric' }); };
      var fechaLarga = function (x) { return x.toLocaleDateString('es-AR', { weekday: 'long', day: 'numeric', month: 'long' }); };
      var txt = plantilla
        .replace(/[\[{]hoy[\]}]/g, '<strong>' + dia(hoy) + '</strong>')
        .replace(/[\[{]dia[\]}]/g, '<strong>' + dia(d) + '</strong>')
        .replace(/[\[{]fecha_larga[\]}]/g, '<strong>' + fechaLarga(d) + '</strong>')
        .replace(/[\[{]fecha[\]}]/g, '<strong>' + fecha(d) + '</strong>');
      var out = el.querySelector('[data-cl-despacho-txt]') || el;
      out.innerHTML = txt;
    });
  }

  /* ---------- Transformación 3 en 1: pestañas que avanzan solas ---------- */
  function initTransforma(root) {
    $$('[data-cl-tr]', root).forEach(function (tr) {
      if (tr.clReady) return; tr.clReady = true;
      var tabs = $$('[data-cl-tab]', tr);
      var panels = $$('[data-cl-panel]', tr);
      var dur = parseFloat(tr.getAttribute('data-dur') || '0') * 1000;
      /* fijo: solo en el editor, al elegir un bloque. teclado: mientras se navega con flechas */
      var actual = 0, timer = null, visible = false, fijo = false, teclado = false;
      function activar(i) {
        actual = (i + tabs.length) % tabs.length;
        tabs.forEach(function (t, k) {
          var on = k === actual;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var bar = t.querySelector('.cl-tr__barra i');
          if (bar && on) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
        });
        panels.forEach(function (p, k) {
          var on = k === actual;
          p.classList.toggle('is-on', on);
          p.setAttribute('aria-hidden', on ? 'false' : 'true');
          var v = p.querySelector('video');
          if (v) { if (on && visible) { v.currentTime = 0; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else { v.pause(); } }
        });
        programar();
      }
      /* Sigue pasando sola aunque toquen una pestaña o el mouse quede encima:
         solo espera mientras no se ve en pantalla o la pestaña del navegador está oculta */
      function programar() {
        clearTimeout(timer);
        if (!dur || fijo || teclado || !visible || document.hidden) return;
        timer = setTimeout(function () { activar(actual + 1); }, dur);
      }
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () { activar(k); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); activar(actual + 1); tabs[actual].focus(); }
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); activar(actual - 1); tabs[actual].focus(); }
        });
      });
      tr.addEventListener('focusin', function (e) {
        if (e.target.matches && e.target.matches(':focus-visible')) { teclado = true; tr.classList.add('is-pausa'); clearTimeout(timer); }
      });
      tr.addEventListener('focusout', function () {
        if (teclado) { teclado = false; tr.classList.remove('is-pausa'); activar(actual); }
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) clearTimeout(timer); else if (visible) activar(actual);
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          visible = en[0].isIntersecting;
          if (visible) activar(actual); else clearTimeout(timer);
        }, { threshold: 0.35 }).observe(tr);
      } else { visible = true; }
      tr.clActivar = function (i) { fijo = true; activar(i); };
      activar(0);
    });
  }

  /* ---------- Bolsillos: puntos sobre la foto + lista ---------- */
  function initBolsillos(root) {
    $$('[data-cl-bol]', root).forEach(function (b) {
      if (b.clReady) return; b.clReady = true;
      var pins = $$('[data-cl-pin]', b);
      var items = $$('[data-cl-item]', b);
      /* Cada punto sabe a qué renglón de la lista corresponde (puede haber renglones sin punto) */
      var nDe = function (p, k) { return p.hasAttribute('data-cl-n') ? +p.getAttribute('data-cl-n') : k; };
      function activar(i) {
        pins.forEach(function (p, k) { var on = nDe(p, k) === i; p.classList.toggle('is-on', on); p.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        items.forEach(function (it, k) { it.classList.toggle('is-on', k === i); });
      }
      pins.forEach(function (p, k) {
        var n = nDe(p, k);
        p.addEventListener('click', function () {
          activar(n);
          var it = items[n];
          if (it && window.innerWidth < 990) it.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
        });
        p.addEventListener('mouseenter', function () { activar(n); });
      });
      items.forEach(function (it, k) {
        it.addEventListener('click', function () { activar(k); });
        it.addEventListener('mouseenter', function () { activar(k); });
      });
      b.clActivar = activar;
      activar(0);
    });
  }

  /* ---------- Carriles con flechas ---------- */
  function initCarriles(root) {
    $$('[data-cl-carril]', root).forEach(function (c) {
      if (c.clReady) return; c.clReady = true;
      var id = c.id;
      var prev = document.querySelector('[data-cl-carril-prev="' + id + '"]');
      var next = document.querySelector('[data-cl-carril-next="' + id + '"]');
      function paso() {
        var item = c.firstElementChild;
        if (!item) return c.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(c).columnGap || '16') || 16;
        return item.getBoundingClientRect().width + gap;
      }
      function estado() {
        if (prev) prev.disabled = c.scrollLeft <= 4;
        if (next) next.disabled = c.scrollLeft + c.clientWidth >= c.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { c.scrollBy({ left: -paso(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { c.scrollBy({ left: paso(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      c.addEventListener('scroll', function () { window.requestAnimationFrame(estado); }, { passive: true });
      window.addEventListener('resize', estado);
      estado();
    });
  }

  /* ---------- WhatsApp: saludo una vez por visita ---------- */
  function initWhatsapp() {
    var wa = document.querySelector('[data-cl-wa]');
    if (!wa) return;
    var demora = parseInt(wa.getAttribute('data-saludo') || '0', 10);
    if (!demora) return;
    var visto = false;
    try { visto = sessionStorage.getItem('cl-wa-saludo') === '1'; } catch (e) {}
    if (visto) return;
    setTimeout(function () {
      wa.classList.add('is-saludo');
      try { sessionStorage.setItem('cl-wa-saludo', '1'); } catch (e) {}
      setTimeout(function () { wa.classList.remove('is-saludo'); }, 6000);
    }, demora * 1000);
  }

  /* ---------- Cupón de descuento en el carrito ---------- */
  /* Escucha en document: el cajón se vuelve a dibujar entero y el cupón llega sin listeners propios */
  function cuponCodigos(box) {
    return $$('[data-cl-cupon-codigo]', box).map(function (li) { return li.getAttribute('data-cl-cupon-codigo'); });
  }
  function cuponAplica(cart, code) {
    var c = code.toLowerCase();
    var hit = (cart.discount_codes || []).filter(function (d) { return (d.code || '').toLowerCase() === c; })[0];
    if (hit) return !!hit.applicable;
    var titulos = (cart.cart_level_discount_applications || []).map(function (d) { return (d.title || '').toLowerCase(); });
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        titulos.push(((a.discount_application && a.discount_application.title) || '').toLowerCase());
      });
    });
    return titulos.indexOf(c) > -1;
  }
  function cuponPedir(box, codigos, nuevo) {
    var msg = box.querySelector('[data-cl-cupon-msg]');
    var cajon = box.closest('cart-drawer');
    var url = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js';
    var cuerpo = { discount: codigos.join(',') };
    if (cajon) cuerpo.sections = 'cart-drawer,cart-icon-bubble';
    var pedir = function (b) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
    };
    box.classList.add('is-cargando');
    if (msg) msg.textContent = nuevo ? 'Aplicando el cupón…' : 'Quitando el cupón…';
    return pedir(cuerpo)
      .then(function (cart) {
        if (nuevo && !cuponAplica(cart, nuevo)) {
          /* No existe o no aplica: se saca del carrito y se avisa, sin redibujar */
          var previos = codigos.filter(function (c) { return c.toLowerCase() !== nuevo.toLowerCase(); });
          pedir({ discount: previos.join(',') }).catch(function () {});
          box.classList.remove('is-cargando');
          if (msg) msg.textContent = 'Ese cupón no existe o no aplica a esta compra.';
          return;
        }
        if (cajon && cart.sections && cajon.renderContents) {
          cajon.renderContents({ sections: cart.sections });
          var otro = document.querySelector('#CartDrawer [data-cl-cupon-msg]');
          if (otro && nuevo) otro.textContent = '¡Listo! Cupón aplicado.';
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        box.classList.remove('is-cargando');
        if (msg) msg.textContent = 'No pudimos aplicar el cupón. Probá de nuevo.';
      });
  }
  function initCupon() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('[data-cl-cupon-form]');
      if (!form) return;
      e.preventDefault();
      var box = form.closest('[data-cl-cupon]');
      var input = form.querySelector('input');
      var msg = box.querySelector('[data-cl-cupon-msg]');
      var code = (input.value || '').trim();
      if (!code) { if (msg) msg.textContent = 'Escribí el cupón.'; input.focus(); return; }
      var actuales = cuponCodigos(box);
      var ya = actuales.some(function (c) { return c.toLowerCase() === code.toLowerCase(); });
      if (ya) { if (msg) msg.textContent = 'Ese cupón ya está aplicado.'; return; }
      cuponPedir(box, actuales.concat([code]), code);
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-cl-cupon-quitar]');
      if (!b) return;
      var box = b.closest('[data-cl-cupon]');
      var quitar = b.getAttribute('data-cl-cupon-quitar').toLowerCase();
      cuponPedir(box, cuponCodigos(box).filter(function (c) { return c.toLowerCase() !== quitar; }), null);
    });
  }

  /* ---------- Contador de la oferta (fecha de fin real: al llegar se oculta, no se reinicia) ---------- */
  function initReloj(root) {
    $$('[data-cl-reloj]', root).forEach(function (el) {
      if (el.clReady) return; el.clReady = true;
      var fin = Date.parse(el.getAttribute('data-fin') || '');
      if (isNaN(fin)) { el.hidden = true; return; }
      var dos = function (n) { return (n < 10 ? '0' : '') + n; };
      var p = {};
      ['d', 'h', 'm', 's'].forEach(function (k) { p[k] = $('[data-cl-reloj-' + k + ']', el); });
      var t;
      function pintar() {
        var resto = Math.floor((fin - Date.now()) / 1000);
        if (resto <= 0) { el.hidden = true; clearInterval(t); return; }
        var d = Math.floor(resto / 86400);
        if (p.d) p.d.textContent = dos(d);
        if (p.h) p.h.textContent = dos(Math.floor(resto % 86400 / 3600));
        if (p.m) p.m.textContent = dos(Math.floor(resto % 3600 / 60));
        if (p.s) p.s.textContent = dos(resto % 60);
        el.classList.toggle('sin-dias', d === 0);
      }
      pintar();
      t = setInterval(pintar, 1000);
    });
  }

  /* ---------- Arranque ---------- */
  function initTodo(root) {
    initGaleria(root);
    initProducto(root);
    initDespacho(root);
    initTransforma(root);
    initBolsillos(root);
    initCarriles(root);
    initVideos(root);
    initReels(root);
    initReloj(root);
    initReveal(root);
  }

  function arrancar() {
    document.documentElement.classList.add('cl-js');
    initTodo(document);
    initWhatsapp();
    initCupon();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();

  /* Editor de Shopify: re-armar al editar y mostrar el bloque elegido */
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var b = e.target;
    var tr = b.closest && b.closest('[data-cl-tr]');
    if (tr && tr.clActivar) { var i = $$('[data-cl-tab]', tr).indexOf(b); if (i > -1) tr.clActivar(i); }
    var bol = b.closest && b.closest('[data-cl-bol]');
    if (bol && bol.clActivar) { var j = $$('[data-cl-item]', bol).indexOf(b); if (j > -1) bol.clActivar(j); }
  });

  window.Cielu = { formatMoney: formatMoney };
})();
